// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_noUpdatesInfo = (i) => `Wir senden nur Infos zu diesem einen Event. Niemals Spam.`